/* unplugin-vue-components disabled */import { render } from "./VirtualScrolling.vue?vue&type=template&id=2f9e9274&scoped=true"
import script from "./VirtualScrolling.vue?vue&type=script&lang=js"
export * from "./VirtualScrolling.vue?vue&type=script&lang=js"

import "./VirtualScrolling.vue?vue&type=style&index=0&id=2f9e9274&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9e9274"]])

export default __exports__